import React from 'react';
function CustomerService({ ...r }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22" {...r}>
			<path
				fill="#272727"
				d="M18.938 6.999H20a2 2 0 012 2v4a2 2 0 01-2 2h-1.062a8 8 0 01-7.938 7v-2a6 6 0 006-6v-6a6 6 0 10-12 0v7H2a2 2 0 01-2-2v-4a2 2 0 012-2h1.062a8.001 8.001 0 0115.876 0zM2 8.999v4h1v-4H2zm17 0v4h1v-4h-1zM6.76 14.784l1.06-1.696a5.972 5.972 0 003.18.91 5.972 5.972 0 003.18-.91l1.06 1.696A7.963 7.963 0 0111 15.999a7.963 7.963 0 01-4.24-1.215z"
			></path>
		</svg>
	);
}

export default CustomerService;
